import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
var rand = require('shortid')

class HiddenBoxClass extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any
    })
  }

  constructor (props) {
    super(props)
    this.state = {
      controlId: rand.generate()
    }
  }

  static defaultProps = {
    ColSize: 0,
    PostComponent: null
  }

  render () {
    const { input: { name } } = this.props
    return (
      <span style={{display: 'none'}}>{name}</span>
    )
  }
};

export const HiddenBox = (props) => { return <Field name={props.name} {...props} component={HiddenBoxClass} /> } // eslint-disable-line
export default HiddenBox
